(() => {
  const drawer = document.getElementById('kn-cart');
  if (!drawer) return;
  const root = drawer.dataset.root;
  const status = drawer.querySelector('.kn-cart-status');
  const list = drawer.querySelector('.kn-cart-items');
  const checkout = drawer.querySelector('[data-kn-checkout]');
  let opener, busy = false;
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const request = async (path, options) => {
    const response = await fetch(root + path, {credentials:'same-origin', ...options});
    const body = await response.json();
    if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : drawer.dataset.error);
    return body;
  };
  const money = (amount, currency) => new Intl.NumberFormat('fr-MA', {style:'currency',currency}).format(amount / 100);
  const show = () => {
    if (!drawer.open) { opener = document.activeElement; drawer.showModal(); }
    document.documentElement.classList.add('kn-cart-open');
  };
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('kn-cart-open');
    opener?.focus();
  });
  const paint = cart => {
    list.replaceChildren();
    if (!cart.items.length) list.append(node('p',drawer.dataset.empty,'kn-cart-empty'));
    cart.items.forEach(item => {
      const row=node('article',undefined,'kn-cart-item');
      if (item.image) { const img=node('img'); img.src=item.image;img.alt=item.product_title;img.width=76;img.height=95;row.append(img); }
      else row.append(node('div'));
      const body=node('div'), title=node('h3');
      const link=node('a',item.product_title);link.href=item.url;title.append(link);body.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') body.append(node('p',item.variant_title));
      body.append(node('p',money(item.final_line_price,cart.currency)));
      const label=node('label',drawer.dataset.quantity), input=node('input');
      input.type='number';input.min='1';input.step='1';input.value=item.quantity;input.dataset.key=item.key;
      input.setAttribute('aria-label',drawer.dataset.quantity+' — '+item.product_title);
      input.addEventListener('change',() => {
        const quantity=Number(input.value);
        if (!Number.isInteger(quantity)||quantity<1) {input.value=item.quantity;return;}
        change(item.key,quantity);
      });
      label.append(input);body.append(label);
      const remove=node('button',drawer.dataset.remove);remove.type='button';remove.addEventListener('click',()=>change(item.key,0));body.append(remove);row.append(body);list.append(row);
    });
    drawer.querySelector('[data-kn-cart-total]').textContent=money(cart.total_price,cart.currency);
    document.querySelectorAll('[data-kn-cart-count]').forEach(el=>el.textContent=cart.item_count);
    checkout.disabled=!cart.item_count;
  };
  const lock = value => {
    busy=value;drawer.setAttribute('aria-busy',String(value));
    drawer.querySelectorAll('.kn-cart-items input,.kn-cart-items button').forEach(el=>el.disabled=value);
    if(value)checkout.disabled=true;
  };
  const change = async (key,quantity) => {
    if(busy)return;
    const focusedKey=document.activeElement?.dataset.key;
    lock(true);status.textContent=drawer.dataset.loading;
    try {paint(await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})}));status.textContent='';}
    catch(error){status.textContent=error.message;try{paint(await request('cart.js'));}catch{checkout.disabled=true;}}
    finally{lock(false);if(focusedKey){Array.from(list.querySelectorAll('input')).find(el=>el.dataset.key===focusedKey)?.focus();}}
  };
  document.addEventListener('click',async event=>{
    if(event.target.closest('[data-kn-cart-close]'))drawer.close();
    const trigger=event.target.closest('[data-kn-cart-open]');
    if(!trigger)return;
    event.preventDefault();show();status.textContent=drawer.dataset.loading;
    try{paint(await request('cart.js'));status.textContent='';}catch(error){status.textContent=error.message;checkout.disabled=true;}
  });
  drawer.addEventListener('click',event=>{
    if(event.target!==drawer)return;
    const rect=drawer.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)drawer.close();
  });
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('.kn-purchase-form');
    if(!form)return;
    event.preventDefault();
    const submit=form.querySelector('[type="submit"]'),errorBox=form.querySelector('.kn-purchase-error');
    if(submit.disabled||form.dataset.submitting)return;
    form.dataset.submitting='true';submit.disabled=true;errorBox.textContent=drawer.dataset.loading;
    let added=false;
    try{
      await request('cart/add.js',{method:'POST',body:new FormData(form)});added=true;
      errorBox.textContent=drawer.dataset.added;show();
      paint(await request('cart.js'));status.textContent=drawer.dataset.added;
    }catch(error){if(added){status.textContent=drawer.dataset.error;checkout.disabled=true;}else errorBox.textContent=error.message;}
    finally{submit.disabled=false;delete form.dataset.submitting;}
  });
})();
